import React from "react";
import styles from "./ConfirmOrder.module.css";
import OrderList from "../Address/OrderList/OrderList";

const AddressInfoA = ({ address }) => {
    return (
        <div className={styles.addressCard}>
            <p><strong>Nume:</strong> {address.name}</p>
            <p><strong>Email:</strong> {address.email}</p>
            <p><strong>Telefeon:</strong> {address.phone}</p>
            {address.companyName && <p><strong> Numele companiei:</strong> {address.companyName}</p>}
            {address.cui && <p><strong> CUI/TVA:</strong> {address.cui}</p>}
            <p><strong>Strada și numărul:</strong> {address.address}</p>
            <p><strong>Oraș:</strong> {address.city}</p>
            <p><strong>Cod poștal:</strong> {address.postalCode}</p>
            <p><strong>Țară:</strong> {address.country}</p>
        </div>
    );
};
const ConfirmOrder = (props) => {
    const isMobile = (window.innerWidth <= 768) ? true : false;

    const handleConfirmOrder = () => {
        props.setCart([])
        props.setCurrentStep(3)
    }

    return (
        <div className={styles.content}>
            {isMobile && <div className={styles.title}>
                <h2>Verifică informațiile</h2>
            </div>}
            <div className={styles.container}>
                <div className={styles.form}>
                    {isMobile || <h1>Verifică informațiile</h1>}
                    <h2>Adresa de livrare</h2>
                    <AddressInfoA address={props.deliveryAddress} />
                    {props.useSameAddress ||
                        <>
                            <h2>Adresa de facturare</h2>
                            <AddressInfoA address={props.billingAddress} />
                        </>
                    }
                </div>
                <div className={styles.cartSummary}>
                    <OrderList cart={props.cart} />
                    <div className={styles.confirm}>
                        <button type="button" className={styles.nextButton} onClick={handleConfirmOrder}>Trimite comanda</button>
                    </div>
                </div>
            </div>
            <div className={styles.actions}>
                <button type="button" className={styles.backButton} onClick={() => props.setCurrentStep(1)}>
                    <i className="fa-solid fa-chevron-left" /> Editează adresa
                </button>
            </div>
        </div>
    );
};

export default ConfirmOrder;